module.exports = __webpack_public_path__ + "img/code4.a61f92a9.png";